module.exports = __webpack_public_path__ + "img/camera.e8ed93a0.jpg";